import React, { createContext, useReducer, useContext, useEffect } from "react";

const initialState = {
  newTechnicalTicket: {},
};

const TechnicalTicketCreateContext = createContext(initialState);

const technicalTicketCreateReducer = (state, action) => {
  switch (action.type) {
    case "SET_NEW_TECH_TICKET":
      return {
        newTechnicalTicket: action.payload,
      };
    case "RESET_STATE":
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export const TechnicalTicketCreateProvider = ({ children }) => {
  const [state, dispatch] = useReducer(
    technicalTicketCreateReducer,
    initialState,
    () => {
      const localData = localStorage.getItem("technicalTicketCreateState");
      return localData ? JSON.parse(localData) : initialState;
    },
  );

  useEffect(() => {
    localStorage.setItem("technicalTicketCreateState", JSON.stringify(state));
  }, [state]);

  const purgeTechTicketCreateState = () => {
    localStorage.removeItem("technicalTicketCreateState");
    dispatch({ type: "RESET_STATE" });
  };

  return (
    <TechnicalTicketCreateContext.Provider
      value={{ state, dispatch, purgeTechTicketCreateState }}
    >
      {children}
    </TechnicalTicketCreateContext.Provider>
  );
};

export const useTechnicalTicketCreate = () => {
  const context = useContext(TechnicalTicketCreateContext);
  if (!context) {
    throw new Error(
      "useTechnicalTicketCreate must be used within an TechnicalTicketCreateProvider",
    );
  }
  return context;
};
